import { createSlice } from "@reduxjs/toolkit";
import { reKyc_AddBankThunk } from "./thunk";

export const initialState = {
  reKyc_AddBankData: [],
  reKyc_AddBankError: "", // for error message
  reKyc_AddBankLoading: false,
};

const Re_Kyc_Add_Bank = createSlice({
  name: "Re_Kyc_Add_Bank",
  initialState,
  reducers: {
    resetReKycAddBankData: (state) => {
      state.reKyc_AddBankData = [];
      state.reKyc_AddBankError = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(reKyc_AddBankThunk.pending, (state) => {
      state.reKyc_AddBankLoading = true;
      // state.reKyc_AddBankData = [];
      state.reKyc_AddBankError = "";
    });
    builder.addCase(reKyc_AddBankThunk.fulfilled, (state, action) => {
      const newData = Array.isArray(action.payload.data)
        ? action.payload.data
        : [action.payload.data];
    
      state.reKyc_AddBankData = [...state.reKyc_AddBankData, ...newData];
      state.reKyc_AddBankLoading = false;
    });
    
    builder.addCase(reKyc_AddBankThunk.rejected, (state, action) => {
      state.reKyc_AddBankError =
        action.error?.message ||
        action.payload?.message ||
        "An unknown error occurred";
      state.reKyc_AddBankLoading = false;
    });
  },
});

export const { apiRequest, apiError, resetReKycAddBankData } = Re_Kyc_Add_Bank.actions;

export default Re_Kyc_Add_Bank.reducer;
